<template>
<div>
    <div v-for="(item, i) in sequence" :key="i">
        <ArticlePage :sequence="articlePageWidgets" />
    </div>
</div>
</template>

<script>
import ArticlePage from "@/components/ContentSite/ArticlePage/ArticlePage.vue";
import { useContentStore } from "@/stores/content.js"

export default {
    name: "ArticlePageLayout",
    setup() {
        const contentStore = useContentStore();
        return { contentStore };
    },		
    components: {
        ArticlePage
    },
    data() {
        return {
            sequence: ["ArticlePage"],
            articlePageWidgets: []
        }
    },
    mounted() {
        this.contentStore.getArticleWidgetsAsync({
            endpoint: this.$route.name,
        }).then((response) => {
            this.articlePageWidgets = response.data.Result;
        });
    }
}
</script>
